import { withForm } from '@/components/form';
import { SectionCard } from '@/components/ui';

import type { EventFormItem } from '../../contactSchema';
import { defaultFormValues, eventRoleEnum, eventTypeEnum } from '../../contactSchema';
import { AddItemButton, RepeaterItem } from './RepeaterItem';

const titleCase = (s: string) => (s ? s[0].toUpperCase() + s.slice(1) : s);

const TYPE_OPTIONS = [
  { value: '', label: '—' },
  ...eventTypeEnum.options.filter((v) => v !== '').map((v) => ({ value: v, label: titleCase(v) })),
];

const ROLE_OPTIONS = [
  { value: '', label: '—' },
  ...eventRoleEnum.options.filter((v) => v !== '').map((v) => ({ value: v, label: titleCase(v) })),
];

const empty = (): EventFormItem => ({ eventName: '' });

export const EventsSection = withForm({
  defaultValues: defaultFormValues,
  render: function EventsSection({ form }) {
    return (
      <SectionCard
        title="Events attended"
        actions={<AddItemButton onClick={() => form.pushFieldValue('eventsAttended', empty())} />}
      >
        <form.AppField name="eventsAttended">
          {(field) => (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {(field.state.value ?? []).map((_, i) => (
                <RepeaterItem key={i} onRemove={() => field.removeValue(i)} removeLabel="Remove event">
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    <div className="ds-form-grid-3">
                      <form.AppField name={`eventsAttended[${i}].eventName`}>
                        {(f) => <f.TextField label="Event name" required />}
                      </form.AppField>
                      <form.AppField name={`eventsAttended[${i}].type`}>
                        {(f) => <f.Select label="Type" options={TYPE_OPTIONS} />}
                      </form.AppField>
                      <form.AppField name={`eventsAttended[${i}].role`}>
                        {(f) => <f.Select label="Role" options={ROLE_OPTIONS} />}
                      </form.AppField>
                    </div>
                    <div className="ds-form-grid-3">
                      <form.AppField name={`eventsAttended[${i}].startDate`}>
                        {(f) => <f.DatePicker label="Start date" />}
                      </form.AppField>
                      <form.AppField name={`eventsAttended[${i}].endDate`}>
                        {(f) => <f.DatePicker label="End date" />}
                      </form.AppField>
                      <form.AppField name={`eventsAttended[${i}].location`}>
                        {(f) => <f.TextField label="Location" />}
                      </form.AppField>
                    </div>
                  </div>
                </RepeaterItem>
              ))}
            </div>
          )}
        </form.AppField>
      </SectionCard>
    );
  },
});
